<template>
    <div class="used-car-item">
        <UsedCarListItem :item="data" />
        <!-- <van-cell>
            <template slot="title">
                车价
            </template>
            {{ data.channel_amount + data.deposit + data.used_car_shop.server_amount }}
        </van-cell> -->
        <van-cell is-link @click="payShowPicker=true">
            <template slot="title">
                付款方式
            </template>
            {{ pay_style_name }}
        </van-cell>
        <van-cell is-link @click="receiveShowPicker=true">
            <template slot="title">
                提车地点
            </template>
            {{ receive_style_name }}
        </van-cell>
        <van-cell is-link @click="dateShowPicker=true">
            <template slot="title">
                预约提车时间
            </template>
            {{ postData.receive_plan_date }}
        </van-cell>
        <van-cell>
            <template slot="title">
                保修政策
            </template>
            {{ maintenance }}
        </van-cell>
        <van-cell>
            <template slot="title">
                店铺服务
            </template>
            {{ data.used_car_shop.package.name }}
        </van-cell>
        <UsedCarFooter />
        <van-submit-bar label="预付定金" :price="data.deposit * 100" button-text="支付订金" @submit="onBuy" />
        <van-popup v-model="dateShowPicker" position="bottom">
            <van-datetime-picker
                type="date"
                title="预约提车时间"
                @confirm="onDateConfirm"
                @cancel="dateShowPicker = false"
            />
        </van-popup>
        <van-popup v-model="payShowPicker" position="bottom">
            <van-picker
                title="选择付款方式"
                :columns="pay_style"
                @change="onPickPay"
                @cancel="payShowPicker=false"
                />
        </van-popup>
        <van-popup v-model="receiveShowPicker" position="bottom">
            <van-picker
                title="选择提车地点"
                :columns="receive_style"
                @change="onPickReceive"
                @cancel="receiveShowPicker=false"
                />
        </van-popup>
    </div>
</template>

<script>
import { 
    NavBar,
    Grid,
    GridItem,
    Cell,
    Image,
    Row,
    Col,
    Icon, 
    Loading, 
    List,
    DatetimePicker,
    Popup,
    Picker,
    SubmitBar
} from 'vant'

import { UsedCarShopApi, UsedCarOrderApi } from '@/api/usedcar'
import UsedCarListItem from '@/view/usedcar/components/usedcarlistitem'
import UsedCarFooter from '@/view/usedcar/components/usedcarfooter'
import { getCurDate } from '@/utils/dateutils'
import { payment } from '@/utils/payment'

export default {
    name: 'UsedCarBuy',
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [Cell.name]: Cell,
        [DatetimePicker.name]: DatetimePicker,
        [Popup.name]: Popup,
        [Picker.name]: Picker,
        [SubmitBar.name]: SubmitBar,
        UsedCarListItem,
        UsedCarFooter
    },
    computed: {
        maintenance() {
            var tmp = this.data.maintenance.filter((it) => it.style === 40)
            if (tmp.length === 1) {
                const item = tmp[0]
                return item.content
            }
            return ''
        },
    },
    data() {
        return {
            id: null,
            data: {
                maintenance: [],
                used_car_shop: {
                    package: {
                        name: null,
                        server_amount: 0
                    },
                    servers: [],
                    versions: []
                }
            },
            receive_style_name: '所在地提车',
            receive_style: [
                '所在地提车',
                '店铺提车',
            ],
            pay_style_name: '全款',
            pay_style: [
                '全款',
                '分期(首付30%,分36期)'
            ],
            postData: {
                usedcar: null,
                channel_amount: null,
                shop_server_amount: null,
                deposit: null,
                receive_style: 0,
                receive_plan_date: null,
                pay_style: 0
            },
            dateShowPicker: false,
            payShowPicker: false,
            receiveShowPicker: false,
            loading: false,
        }
    },
    mounted() {
        this.id = this.$route.params.id
        console.log('item')
        console.log(this.id)
        this.getData()
        this.postData.usedcar = this.$route.params.id
        this.postData.receive_plan_date = this.$moment(getCurDate()).format('YYYY-MM-DD')
    },
    methods: {
        getData() {
            var that = this
            this.axios.get(UsedCarShopApi + that.id + '/').then((ret) => {
                console.log(ret)
                that.data = ret
            })
        },
        onDateConfirm(date) {
            this.postData.receive_plan_date = this.$moment(date).format('YYYY-MM-DD')
            this.dateShowPicker = false
        },
        onPickPay(con,itm, idx) {
            this.pay_style_name = itm
            this.postData.pay_style = idx
            this.payShowPicker = false
        },
        onPickReceive(con,itm, idx) {
            this.receive_style_name = itm
            this.postData.receive_style = idx
            this.receiveShowPicker = false
        },
        onBuy() {
            var that = this
            that.loading = true
            console.log('data begin')
            console.log(that.postData)
            console.log('data end')
            console.log(that.data)
            this.axios.post(UsedCarOrderApi, that.postData).then((ret) => {
                that.loading = false
                console.log(ret)
                if (ret.flag) {
                    let id = ret.details.id
                    let deposit = ret.details.deposit
                    if (deposit > 0) {
                        const body = '下订:' + that.data.title
                        payment(that, 
                            id,
                            'usedcardeposit', 
                            deposit, 
                            body,
                            '/nt/sucesspage/?title=下订完成&backurl=/nt/usedcar')
                    }
                    
                }
            }).catch((error) => {
                console.log(error)
                that.loading = false
            })
        }
    }
}
</script>

<style lang="less">
.used-car-item {
    .van-button--danger{
        background-color: #2196F3;
    }
}
</style>
